import { render } from "./more-detail.vue?vue&type=template&id=260b56e7&scoped=true"
import script from "./more-detail.vue?vue&type=script&lang=js"
export * from "./more-detail.vue?vue&type=script&lang=js"

import "./more-detail.vue?vue&type=style&index=0&id=260b56e7&lang=scss&scoped=true"
import "./more-detail.vue?vue&type=style&index=1&id=260b56e7&lang=scss&scoped=true"

import exportComponent from "/Users/zuzhiming/xlc-work/xlc-kuihuaguanwang/Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260b56e7"]])

export default __exports__